import { faSyncAlt, IconDefinition } from '@fortawesome/pro-solid-svg-icons'
import { ActionButton } from 'components'
import React, { FC } from 'react'
import './error-retry.scss'

type Props = {
    message: string,
    onRetry: () => void,
    headingText?: string,
    buttonOneText?: string,
    onButtonOneClicked?: () => void,
    buttonOneIcon?: IconDefinition,
    buttonOneColor?: string,
    displayButtonOne?: boolean
    buttonOneWidth?: string,
    customHeading?: () => React.ReactNode
}

export const ErrorRetry: FC<Props> = ({ message, onRetry, buttonOneWidth, displayButtonOne, buttonOneColor, buttonOneText, buttonOneIcon, onButtonOneClicked, headingText, customHeading }) => {
    let heading: React.ReactNode | string = customHeading ? customHeading() : headingText ? headingText : 'Error'

    return (
        <div className={'card-material'}>
            <div className={`error-retry-heading-container`}>
                <div className={'error-retry-heading-title'}>{heading}</div>
            </div>
            <div className={'error-retry-message'}>{message}</div>
            <div className={'action-row'}>
                <ActionButton
                    icon={faSyncAlt}
                    buttonColor={'#EB5757'}
                    onClick={onRetry}
                    buttonText={'Retry'}
                />
                <>
                    {displayButtonOne &&
                        <ActionButton
                            icon={buttonOneIcon!}
                            buttonColor={buttonOneColor}
                            onClick={onButtonOneClicked}
                            buttonText={buttonOneText}
                            buttonWidth={buttonOneWidth}
                        />
                    }
                </>
            </div>
        </div>
    )
}
